export default __webpack_public_path__ + "static/media/bg1.9e60f3c2.jpg";